import { render } from "./LoaderDots.vue?vue&type=template&id=3e11e221&scoped=true&ts=true"
import script from "./LoaderDots.vue?vue&type=script&lang=ts"
export * from "./LoaderDots.vue?vue&type=script&lang=ts"

import "./LoaderDots.vue?vue&type=style&index=0&id=3e11e221&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\devloader-userspace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e11e221"]])

export default __exports__